export const black = "black"
export const white = "white"
export const darkBlue = "#020512"
export const blue = "#194092"
export const yellow = "#F8E71C"
export const gray = "#D8D8D8"
export const lightGray = "#F1F1F1"
export const red = "#D0021B"
